import { createStore } from 'satcheljs';
/**
 * Creates store which reflects the current state of settings under calendar appearance option
 */
export default createStore('calendarAppearanceOption', {
    weekStartDay: null,
    timeIncrement: null,
    workDays: null,
    showWeekNumbers: null,
    firstWeekOfYear: null,
    workingHoursStartTime: null,
    workingHoursEndTime: null,
});
//# sourceMappingURL=store.js.map